import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { data } from "../firebase/firebese";
import Loader from "../components/Loader";
import { Card, Container, Row, Col, Badge, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

export default function MyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notLoggedIn, setNotLoggedIn] = useState(false);
  const [showGift, setShowGift] = useState(false);
  const navigate = useNavigate();

  // دالة لتحديد لون البادج حسب حالة الطلب
  const getStatusBadge = (status) => {
    switch (status) {
      case "تم الإنجاز":
        return <Badge bg="success" className="mx-2">تم الإنجاز</Badge>;
      case "جاري التجهيز":
        return <Badge bg="warning" className="mx-2">جاري التجهيز</Badge>;
      case "تم الطلب":
        return <Badge bg="info" className="mx-2">تم الطلب</Badge>;
      case "تم التسليم":
        return <Badge bg="primary" className="mx-2">تم التسليم</Badge>;
      default:
        return <Badge bg="secondary" className="mx-2">{status || "جديد"}</Badge>;
    }
  };

  // دالة لتحديد أيقونة الحالة
  const getStatusIcon = (status) => {
    switch (status) {
      case "تم الإنجاز":
        return "✅";
      case "جاري التجهيز":
        return "⏳";
      case "تم الطلب":
        return "📋";
      case "تم التسليم":
        return "🎉";
      default:
        return "📝";
    }
  };

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setNotLoggedIn(true);
        setLoading(false);
        navigate("/auth");
        return;
      }
      
      // المستخدم مسجل دخول، جلب الطلبات
      const userDoc = await getDoc(doc(data, "authentact", user.uid));
      if (userDoc.exists()) {
        const actions = userDoc.data().actions || [];
        const userOrders = actions.filter(a => a.type === "order");
        setOrders(userOrders);
        
        // التحقق من عدد الطلبات للهدية
        if (userOrders.length >= 5) {
          setShowGift(true);
          toast.success("🎉 مبروك! لقد وصلت إلى 5 طلبات! لديك هدية من المطعم!");
        }
      }
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, [navigate]);

  if (loading) return <Loader />;

  if (notLoggedIn) {
    return null; // لا تعرض أي شيء، سيتم التوجيه لصفحة تسجيل الدخول
  }

  return (
    <Container className="py-4">
      <h3 className="mb-4 text-center">طلباتي</h3>
      
      {/* نص توضيحي عن نظام الهدية */}
      <div className="text-center mb-4">
        <div className="alert alert-info" style={{ backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
          <p className="mb-2">
            <strong>🎁 نظام الهدية:</strong>
          </p>
          <p className="mb-0">
            في حال وصولك إلى <strong>5 طلبات</strong> من مطعمنا، ستحصل على <strong>هدية خاصة</strong>!
          </p>
        </div>
      </div>
      
      {/* رسالة الهدية */}
      {showGift && (
        <Alert variant="success" className="text-center mb-4">
          <Alert.Heading>
            🎁 هدية من المطعم! 🎁
          </Alert.Heading>
          <p>
            مبروك! لقد وصلت إلى 5 طلبات من مطعمنا!
          </p>
          <p>
            <strong>هديتك:</strong> خصم 20% على طلبك القادم!
          </p>
          <p className="mb-0">
            <small>سيتم تطبيق الخصم تلقائياً عند طلبك التالي</small>
          </p>
        </Alert>
      )}
      
      {/* عرض الطلبات فقط إذا لم تظهر الهدية */}
      {!showGift && (
        <>
          {orders.length === 0 ? (
            <div className="text-center">لا توجد طلبات بعد.</div>
          ) : (
            <Row>
              {orders.map((order, idx) => (
                <Col md={6} key={idx}>
                  <Card className="mb-3 shadow-sm">
                    <Card.Body>
                      <Card.Title className="d-flex justify-content-between align-items-center">
                        <span>
                          {getStatusIcon(order.status)} طلب رقم {idx + 1}
                        </span>
                        {getStatusBadge(order.status)}
                      </Card.Title>
                      <Card.Text>
                        <b>التاريخ:</b> {new Date(order.date).toLocaleString("ar-EG")}
                        <br />
                        <b>رقم الطاولة:</b> {order.tableNumber}
                        <br />
                        <b>المجموع:</b> {order.total} د.أ
                        <br />
                        <b>عدد المنتجات:</b> {order.items?.length}
                        {order.status === "جاري التجهيز" && (
                          <div className="mt-2">
                            <small className="text-warning">
                              ⏰ سيتم تجهيز طلبك قريباً...
                            </small>
                          </div>
                        )}
                        {order.status === "تم الإنجاز" && (
                          <div className="mt-2">
                            <small className="text-success">
                              ✅ تم إنجاز طلبك بنجاح!
                            </small>
                          </div>
                        )}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </>
      )}
      
      {/* عداد الطلبات */}
      <div className="text-center mt-4">
        <Badge bg="info" className="fs-6">
          عدد طلباتك: {orders.length}
        </Badge>
        {orders.length >= 4 && orders.length < 5 && (
          <div className="mt-2">
            <small className="text-warning">
              ⭐ طلب واحد آخر وستحصل على هدية من المطعم!
            </small>
          </div>
        )}
      </div>
    </Container>
  );
} 